module.exports = __webpack_public_path__ + "img/logo_small.1a400bfb.png";